import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RadMonitorComponent } from './rad-monitor.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SharedModule } from 'src/app/modules/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RadMonitorSettingsComponent } from './settings/settings.component';
import { RadMonitorAddEditPrivilegeComponent } from './settings/add-edit-privilege/add-edit-privilege.component';
import { RadMonitorAddEditLocationComponent } from './dialogs/add-edit-location/add-edit-location.component';
import { RadMonitorAddEditRadLocationTypeComponent } from './settings/add-edit-rad-location-type/add-edit-rad-location-type.component';
import { RadMonitorAddEditRadInterlockComponent } from './settings/add-edit-rad-interlock/add-edit-rad-interlock.component';
import { RadMonitorTabComponent } from './monitor-tab/monitor-tab.component';
import { RadNoteComponent } from './dialogs/add-rad-note/add-rad-note.component';
import { RadMonitorAddEditMonitorComponent } from './monitor-tab/add-edit-monitor/add-edit-monitor.component';
import { RadMonitorLocationTabComponent } from './location-tab/location-tab.component';



@NgModule({
  declarations: [
    RadMonitorComponent,
    RadMonitorTabComponent,
    RadMonitorAddEditMonitorComponent,
    RadMonitorSettingsComponent,
    RadMonitorAddEditPrivilegeComponent,
    RadMonitorAddEditLocationComponent,
    RadMonitorAddEditRadLocationTypeComponent,
    RadMonitorAddEditRadInterlockComponent,
    RadNoteComponent,

    RadMonitorLocationTabComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    HttpClientModule,
    ScrollingModule,
    HttpClientModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatRadioModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    MatGridListModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    DragDropModule,
    MatTreeModule,
    MatExpansionModule,
    MatOptionModule,
    MatSidenavModule,
    DatePipe,
    MatToolbarModule,
    QuillModule.forRoot(),
    SharedModule,
  ]
})
export class RadMonitorModule { }
